import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { rtfoConversionFactors } from "./rtfoConversionFactors";

export const RTFOStepdownSummaryTable = ({ stepdownParams, metrics, perfClosure, darkMode, units='metric' }) => {

  const params = [
    'numClusters', 
    'clusterSpacing', 
    'stageLength', 
    'numShots', 
    'N', 
    'perfEfficiency', 
    'Dperf', 
    'kNwb', 
    'bNwb', 
    'rho', 
    'Cd', 
    'pNwb', 
    'pPerf',
    'pPipe',
    'perfClosure',
    'topDepth',
    'bottomDepth',
    'averageDepth',
    'isip'
  ];

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Parameter</TableCell>
          <TableCell align="right">Pre Sand</TableCell>
          <TableCell align="right">Flush</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {params?.map((row) => (
          <TableRow
            key={row}
            sx={{ 
              '&:last-child td, &:last-child th': { border: 0 }, 
              '&:nth-of-type(odd)': {
                backgroundColor: darkMode ? '#263238' : 'whitesmoke',
              }
            }}
          >
            <TableCell component="th" scope="row">
              {getName(row)}
            </TableCell>
            <TableCell align="right">{getValue(row, true)}</TableCell>
            <TableCell align="right">{getValue(row, false)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );


  function getValue(param, preSand) {
    try {
      if (param === 'numShots') {
        return stepdownParams?.[param]?.toFixed(0) || 0;
      } else if (param === 'numClusters') {
        return metrics?.[param]?.toFixed(0) || 0;
      } else if (param === 'clusterSpacing') {
        return (metrics?.[param] * (units === 'field' ? rtfoConversionFactors.clusterSpacing : 1))?.toFixed(1) || 0;
      } else if (param === 'stageLength') {
        return (metrics?.[param] * (units === 'field' ? rtfoConversionFactors.stageLength : 1))?.toFixed(1) || 0;
      } else if (param === 'N') {
        return (preSand ? (stepdownParams?.['preSandNumShots'] || stepdownParams?.['numShots'])?.toFixed(1) : stepdownParams?.['N']?.toFixed(1)) || 0;
      } else if (param === 'Cd') {
        return (preSand ? stepdownParams?.['preSandCd']?.toFixed(2) : stepdownParams?.['Cd']?.toFixed(2)) || 0;
      } else if (param === 'pNwb') {
        return (preSand ? (stepdownParams?.['preSandPNwb'] * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2) : (stepdownParams?.['pNwb'] * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2)) || 0;
      } else if (param === 'kNwb') {
        return ((preSand ? stepdownParams?.['preSandKNwb'] : stepdownParams?.['kNwb']) * (units !== 'field' ? (Math.pow(6.29, (preSand ? stepdownParams?.['preSandBNwb'] : stepdownParams?.['bNwb'])) / 145.38) : 1))?.toFixed(2) || 0;
      } else if (param === 'pPerf') {
        return (preSand ? (stepdownParams?.['preSandPPerf'] * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2) : (stepdownParams?.['pPerf'] * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2)) || 0;
      } else if (param === 'bNwb') {
        return (preSand ? (stepdownParams?.['preSandBNwb'])?.toFixed(2) : stepdownParams?.['bNwb']?.toFixed(2)) || 0;
      } else if (param === 'Dperf') {
        return (preSand ? (Number(stepdownParams?.['preSandDperf']))?.toFixed(2) : (Number(stepdownParams?.['Dperf']))?.toFixed(2)) || 0;
        // return (preSand ? (Number(stepdownParams?.['preSandDperf']) * (units === 'field' ? rtfoConversionFactors.perfDiameter : 1))?.toFixed(2) : (Number(stepdownParams?.['Dperf']) * (units === 'field' ? rtfoConversionFactors.perfDiameter : 1))?.toFixed(2)) || 0;
      } else if (param === 'perfEfficiency') {
        return (preSand ? ((stepdownParams?.['preSandPerfEfficiency']?.toFixed(1) || (stepdownParams?.['preSandNumShots'] / stepdownParams?.['numShots'] * 100)) || 100) : (stepdownParams?.['perfEfficiency']?.toFixed(1) || 0) || 0);
      } else if (param === 'perfClosure') {
        return preSand ? 0 : (perfClosure?.length || 0);
      } else if (param === 'topDepth') {
        return ((preSand ? (stepdownParams?.preSandTopDepth || stepdownParams?.topDepth) : stepdownParams?.topDepth) * (units === 'field' ? rtfoConversionFactors.depth : 1))?.toFixed(1) || 0;
      } else if (param === 'bottomDepth') {
        return ((preSand ? (stepdownParams?.preSandBottomDepth || stepdownParams?.bottomDepth) : stepdownParams?.bottomDepth) * (units === 'field' ? rtfoConversionFactors.depth : 1))?.toFixed(1) || 0;
      } else if (param === 'averageDepth') {
        return ((preSand ? (stepdownParams?.preSandAverageDepth || stepdownParams?.averageDepth) : stepdownParams?.averageDepth) * (units === 'field' ? rtfoConversionFactors.depth : 1))?.toFixed(1) || 0;
      } else if (param === 'isip') {
        return preSand ? ((stepdownParams?.preSandISIP || stepdownParams?.isip || 0) * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2) : (stepdownParams?.isip * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2);
      } else if (param === 'pPipe') {
        return (preSand ? (stepdownParams?.preSandPPipe * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2) : (stepdownParams?.pPipe * (units === 'field' ? rtfoConversionFactors.pressure : 1))?.toFixed(2)) || 0;
      } else if (param === 'rho') {
        return ((preSand ? (stepdownParams?.preSandRho || stepdownParams?.rho) : stepdownParams?.rho) * (units === 'field' ? 1 : 119.83))?.toFixed(2) || 0;
      } else {
        return stepdownParams?.[param]?.toFixed(2) || 0;
      };  
    } catch (error) {
      return 0;
    };
  };

  function getName(param) {
    switch (param) {
      case 'numClusters':
        return '# Clusters';
      case 'clusterSpacing':
        return `Cluster Spacing (${(units === 'field' ? 'ft' : 'm')})`;
      case 'stageLength':
        return `Stage Length (${(units === 'field' ? 'ft' : 'm')})`;
      case 'numShots':
        return 'Initial Perfs';
      case 'N':
        return 'Open Perfs';
      case 'perfEfficiency':
        return 'Perf Efficiency (%)';
      case 'Dperf':
        return `Dperf (${(units === 'field' ? 'in' : 'mm')})`;
      case 'rho':
        return `Density (${(units === 'field' ? 'lb/gal' : 'kg/m3')})`;
      case 'kNwb':
        return `Knwb (${(units === 'field' ? 'psi/bbl/min' : 'MPa/m3/min')})`;
      case 'bNwb':
        return 'Bnwb';
      case 'Cd':
        return 'Cd (constant)';
      case 'pNwb':
        return `Pnwb (${(units === 'field' ? 'psi' : 'MPa')})`;
      case 'pPerf':
        return `Pperf (${(units === 'field' ? 'psi' : 'MPa')})`;
      case 'perfClosure':
        return 'Rate Drop Events';
      case 'topDepth':
        return `Top Depth (${(units === 'field' ? 'ft' : 'm')})`;
      case 'bottomDepth':
        return `Bottom Depth (${(units === 'field' ? 'ft' : 'm')})`;
      case 'averageDepth':
        return `Depth of Calculation (${(units === 'field' ? 'ft' : 'm')})`;
      case 'isip':
        return `ISIP (${(units === 'field' ? 'psi' : 'MPa')})`;
      case 'pPipe':
        return `Ppipe (${(units === 'field' ? 'psi' : 'MPa')})`;
      default:
        return param;
    };
  };
};